import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import {
  LoadingProgressComponent,
  LoadingStep,
} from '../../../../../common/components/loading-progress/loading-progress';
import { THEME_COLOR } from '../../services/lesson-plan.models';

@Component({
  selector: 'app-step-slides-loading',
  standalone: true,
  imports: [LoadingProgressComponent],
  template: `
    <app-loading-progress
      [title]="title"
      [subtitle]="subtitle"
      [tipText]="tipText"
      [themeColor]="themeColor"
      [steps]="steps"
    ></app-loading-progress>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepSlidesLoadingComponent {
  @ViewChild(LoadingProgressComponent) loadingComponent?: LoadingProgressComponent;

  protected readonly themeColor = THEME_COLOR;
  protected readonly title = 'Creating your presentation';
  protected readonly subtitle = 'Designing slides and teacher scripts for your lesson.';
  protected readonly tipText =
    "We're writing detailed scripts and designing visuals for each slide.";

  protected readonly steps: LoadingStep[] = [
    { id: 1, label: 'Analyzing lesson structure...' },
    { id: 2, label: 'Reviewing learning objectives...' },
    { id: 3, label: 'Designing slide layouts...' },
    { id: 4, label: 'Creating visual suggestions...' },
    { id: 5, label: 'Writing teacher scripts...' },
    { id: 6, label: 'Finalizing presentation...' },
  ];

  /**
   * Complete the progress (called externally when slides are ready).
   */
  complete(): void {
    this.loadingComponent?.complete();
  }
}
